<template>
    <button
        type="button"
        class="sebrae-layout-btn sebrae-topbar__icon-btn"
        :aria-label="rotulo"
        :title="titulo"
        aria-haspopup="true"
        aria-controls="sebrae-tema-menu"
        @click="toggle"
    >
        <i :class="['pi', icone]" aria-hidden="true"></i>
    </button>

    <Menu id="sebrae-tema-menu" ref="menu" :model="itens" :popup="true" append-to="self">
        <template #item="{ item, props }">
            <!--
                aria-current marca o item ativo de forma programática; a classe cuida do
                destaque visual e o pi-check evita depender só de cor para diferenciar
                "sistema" de "escuro" quando o SO já está escuro (os dois pareciam o mesmo botão).
            -->
            <a
                v-bind="props.action"
                class="sebrae-tema-menu__item"
                :class="{ 'sebrae-tema-menu__item--ativo': item.ativo }"
                :aria-current="item.ativo ? 'true' : undefined"
            >
                <span v-bind="props.icon"></span>
                <span v-bind="props.label">{{ item.label }}</span>
                <i v-if="item.ativo" class="pi pi-check sebrae-tema-menu__check" aria-hidden="true"></i>
            </a>
        </template>
    </Menu>
</template>

<script setup>
import { computed, ref } from 'vue';
import Menu from 'primevue/menu';
import { useSebraeTheme } from '@packages/design-system';

const { theme, setTheme } = useSebraeTheme();

const menu = ref(null);

/** Ordem de exibição no menu. Fonte única para rótulo, ícone e estado legível. */
const OPCOES = [
    { valor: 'system', rotulo: 'Sistema', icone: 'pi-desktop', legivel: 'sistema' },
    { valor: 'light', rotulo: 'Claro', icone: 'pi-sun', legivel: 'claro' },
    { valor: 'dark', rotulo: 'Escuro', icone: 'pi-moon', legivel: 'escuro' },
];

const icone = computed(() => OPCOES.find((opcao) => opcao.valor === theme.value)?.icone);

/**
 * Antes o botão era cíclico e só o title revelava o estado; com SO no escuro, "sistema" e
 * "escuro" renderizavam o mesmo ícone e o clique não deixava claro em qual estado se estava.
 * Agora o gatilho abre um menu com rótulos, então o aria-label descreve o estado atual E
 * avisa que a ação é abrir um menu (não mais "mudar para X").
 */
const titulo = computed(() => `Tema: ${OPCOES.find((opcao) => opcao.valor === theme.value)?.legivel}`);
const rotulo = computed(() => `Tema: ${OPCOES.find((opcao) => opcao.valor === theme.value)?.legivel}. Abrir menu de temas`);

const itens = computed(() =>
    OPCOES.map((opcao) => ({
        label: opcao.rotulo,
        icon: `pi ${opcao.icone}`,
        ativo: theme.value === opcao.valor,
        command: () => setTheme(opcao.valor),
    }))
);

function toggle(event) {
    menu.value.toggle(event);
}
</script>

<style scoped>
/* O check reforça o item ativo sem depender só de cor; o negrito é o segundo sinal visual. */
.sebrae-tema-menu__item--ativo {
    font-weight: 600;
}

.sebrae-tema-menu__check {
    margin-left: auto;
    padding-left: 0.5rem;
}
</style>
